import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/baseball';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-242" data-mp="30xq459r7icso">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-243" data-mp="2w56rcf0cflox">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-244" data-mp="2r7wvohmd2dsn">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-245" data-mp="2m8bv62rjlxdt">
            Have you ever felt this way?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-246" data-mp="2i5xbxhjyovm0">
            If you answer yes to even one of these, BASEBALL READY™ is for you.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-247" data-mp="2892d0xjs0t77">
            You deserve an easier way
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-248" data-mp="6ih7zvifv578" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-249" data-mp="3nmfg7qml3t3x">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-250" data-mp="39p0h1u6j46yr">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-251" data-mp="3emitvvno36c1">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-252" data-mp="b5af5ko8kmlj" />
                </span>
                <div data-id="element-253" data-mp="b73c2891rsgc">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-254" data-mp="3sm1p5nvdqn6x">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-255" data-mp="1f7cesrbbua0">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}